import { Component, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './source-name.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSourceName
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - A document title.  This can be an HTML string.
 * @param {string} [url] - The document source url.  If provided this will make the entire title a a clickable href.
 * @param {expression} [on-click] - Angular expression to evaluate on click of the title. $event is the ng-click event.
 *
 * @description
 * `<mw-content-document-source-name>` provides a means for displaying the name of a document source.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Using transclusion -->
 *   <mw-content-document-source-name>New York Times</mw-content-document-source-name>
 *
 *   <!-- Using 'text' input binding -->
 *   <mw-content-document-source-name text="New York Times"></mw-content-document-source-name>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-source-name',
    template: `
        <a class="mw-content-document-source-name" data-tracking-event="documentOperation/open" ng-href="{{::$ctrl.url}}" target="_blank" ng-click="$ctrl.handleSourceNameClick($event);" ng-class="::{'mw-content-document-source-name__no-hover': !$ctrl.url, 'mw-content-document-source-name--unknown': $ctrl.text === 'Unknown'}" translate>
            {{::$ctrl.text}}
            <ng-transclude></ng-transclude>
        </a>
    `,
    legacy: {
        transclude: true
    }
})
export class SourceNameComponent implements OnInit {
    @Input('<') text: string;
    @Input('<') url: string;
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();

    constructor() {
        'ngInject';
    }

    ngOnInit() {
    }

    handleSourceNameClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/source-name/source-name.component.ts